import NewJobTemplate from './NewJobTemplate';

export default NewJobTemplate;
